import OrdersModal from './OrdersModal';

export default OrdersModal;
